import { computed } from 'vue';
import store from '@/store';

export default class ReviewSubmittedNotificationComponent {
	public dismissReviewSubmittedNotification(): void {
		store.mutations.updateWasReviewSubmittedNotificationDismissed(true);
	}
}
